import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsCustomEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-custom-edit',
	path: '/jira/servicedesk/projects/:projectKey/reports/custom/:reportId/edit',
};
